// extracted by mini-css-extract-plugin
export var divider = "_2o-0";
export var dividerText = "_2o-1";